/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * UID of a user or group
 * @export
 * @interface UserGroupUid
 */
export interface UserGroupUid {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUid
     */
    uid?: string;
}

/**
 * Check if a given object implements the UserGroupUid interface.
 */
export function instanceOfUserGroupUid(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserGroupUidFromJSON(json: any): UserGroupUid {
    return UserGroupUidFromJSONTyped(json, false);
}

export function UserGroupUidFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupUid {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
    };
}

export function UserGroupUidToJSON(value?: UserGroupUid | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
    };
}

